import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { MenuGetAllService } from '../../services';

export const fetchMenuGetAll = createAsyncThunk(
    'menuGetAll/fetchMenuGetAll',
    async () => {
        const response = await MenuGetAllService()
        return response.result;
    }
);

const menuGetAllSlice = createSlice({
    name: 'menuGetAll',
    initialState: {
        data: null,
        status: 'idle',
    },
    reducers: {},
    extraReducers: (builder) => {
        builder
            .addCase(fetchMenuGetAll.pending, (state) => {
                state.status = 'loading';
            })
            .addCase(fetchMenuGetAll.fulfilled, (state, action) => {
                state.status = 'succeeded';
                state.data = action.payload;
            })
            .addCase(fetchMenuGetAll.rejected, (state) => {
                state.status = 'failed';
            });
    },
});

export default menuGetAllSlice.reducer;
